import 'twin.macro';
import React, { useEffect, useState } from 'react';
import Joyride from 'react-joyride';
import OnBoardingTooltip from '@teetsh/app/src/components/OnBoardingTooltip';
import H1 from '@teetsh/app/src/components/Typography/Headings/H1';
import useOnboardingEDTStatus from '@teetsh/app/src/containers/EmploiDuTemps/EDT/useOnboardingEDTStatus';
import { tutoUrls } from 'containers/tutoUrls';
import { Trans, useTranslation } from 'react-i18next';
import { bold, ExternalLink, lineBreak } from 'i18n/components';

export function Onboarding() {
  const { disableOnboarding, onFinish, isOpen } = useOnboardingEDTStatus();
  const { t } = useTranslation(['emploiDuTemps']);
  const [ride, setRide] = useState<any>({
    steps: [
      {
        target: 'body',
        content: (
          <div>
            <div tw="text-center mb-4">
              <div tw="text-7xl mb-4">👋</div>
              <H1 tw="mb-8">{t('emploiDuTemps:onboarding.title')}</H1>
            </div>
            <div tw="text-center mb-4">
              <span tw="text-xl">
                {t('emploiDuTemps:onboarding.description')}
              </span>
            </div>
          </div>
        ),
        hideBackButton: true,
        disableBeacon: true,
        locale: {
          forceNext: t('emploiDuTemps:onboarding.next'),
        },
        preventFurtherDisplayFct: async () => {
          disableOnboarding();
        },
        placement: 'center',
        floaterProps: {
          styles: {
            floater: {
              overflowY: 'auto',
              height: '100%',
              // width: '100%',
            },
          },
        },
      },
      {
        target: '#edt-settings',
        // spotlightPadding: 0,
        content: (
          <div tw="max-w-lg">
            <h3 tw="mb-3">{t('emploiDuTemps:onboarding.edtSettings.title')}</h3>
            <p>{t('emploiDuTemps:onboarding.edtSettings.description')}</p>
          </div>
        ),
        hideBackButton: true,
        disableBeacon: true,
        placement: 'left',
      },
      {
        target: '#edt-volume-horaire',
        // spotlightPadding: 0,
        content: (
          <div tw="max-w-lg">
            <h3 tw="mb-3">
              {t('emploiDuTemps:onboarding.edtVolumeHoraire.title')}
            </h3>
            <p>{t('emploiDuTemps:onboarding.edtVolumeHoraire.description')}</p>
          </div>
        ),
        hideBackButton: true,
        disableBeacon: true,
        placement: 'left',
      },
      {
        target: '#edt-preview',
        // spotlightPadding: 0,
        content: (
          <div tw="max-w-lg">
            <h3 tw="mb-3">{t('emploiDuTemps:onboarding.edtDownload.title')}</h3>
            <p>{t('emploiDuTemps:onboarding.edtDownload.description')}</p>
          </div>
        ),
        hideBackButton: true,
        disableBeacon: true,
        placement: 'left',
      },

      {
        target: '#edt-transfert-cj',
        // spotlightPadding: 0,
        content: (
          <div tw="max-w-lg">
            <h3 tw="mb-3">{t('emploiDuTemps:onboarding.cjTransfert.title')}</h3>
            <p>{t('emploiDuTemps:onboarding.cjTransfert.description')}</p>
          </div>
        ),
        hideBackButton: true,
        disableBeacon: true,
        placement: 'left',
      },

      {
        target: 'body',
        content: (
          <div tw="max-w-xl">
            <div tw="text-center mb-4">
              <div tw="text-7xl mb-4">☝</div>
              <H1 tw="mb-8">{t('emploiDuTemps:onboarding.lastInfo.title')}</H1>
            </div>
            <div tw="text-center mb-8">
              <span tw="text-xl">
                <Trans
                  i18nKey="emploiDuTemps:onboarding.lastInfo.videoDescription"
                  components={{
                    externalLink: <ExternalLink href={tutoUrls.multiniveau} />,
                  }}
                ></Trans>
              </span>
            </div>
            <div tw="text-center text-xl mb-4">
              <Trans
                i18nKey="emploiDuTemps:onboarding.lastInfo.edtFree"
                components={{ bold, lineBreak }}
              />
            </div>
          </div>
        ),
        hideBackButton: true,
        disableBeacon: true,
        locale: {
          forceNext: t('emploiDuTemps:onboarding.start'),
        },
        placement: 'center',
        floaterProps: {
          styles: {
            floater: {
              overflowY: 'auto',
              height: '100%',
              // width: '100%',
            },
          },
        },
      },
    ],
  });
  useEffect(() => {
    setRide({ ...ride, run: isOpen });
  }, []);

  // Le disableScrollParentFix est important
  // sinon ça ajoute un overflow inherit au parent
  // ce qui peut fuck complètement overflow du parent ...
  return (
    <Joyride
      disableScrollParentFix
      disableScrolling
      steps={ride.steps as any}
      run={isOpen}
      tooltipComponent={props => <OnBoardingTooltip joyrideProps={props} />}
      locale={{
        skip: t('emploiDuTemps:onboarding.buttons.skip'),
        close: t('emploiDuTemps:onboarding.buttons.close'),
        next: t('emploiDuTemps:onboarding.buttons.next'),
        back: t('emploiDuTemps:onboarding.buttons.back'),
        last: t('emploiDuTemps:onboarding.buttons.last'),
      }}
      callback={data => {
        const { status } = data;
        if (status === 'finished') {
          onFinish();
        }
      }}
    />
  );
}
